/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignCrossTenantRolesRequest,
  RevokeCrossTenantRolesRequest,
  RoleAssignmentResponse,
  UserAccessListResponse,
} from '../models/index';
import {
    AssignCrossTenantRolesRequestFromJSON,
    AssignCrossTenantRolesRequestToJSON,
    RevokeCrossTenantRolesRequestFromJSON,
    RevokeCrossTenantRolesRequestToJSON,
    RoleAssignmentResponseFromJSON,
    RoleAssignmentResponseToJSON,
    UserAccessListResponseFromJSON,
    UserAccessListResponseToJSON,
} from '../models/index';

export interface AssignCrossTenantRolesOperationRequest {
    assignCrossTenantRolesRequest: AssignCrossTenantRolesRequest;
    sessionId?: string;
}

export interface CheckCrossTenantAccessRequest {
    userId: string;
    targetTenantId: string;
    sessionId?: string;
}

export interface GetAccessibleUsersRequest {
    sessionId?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    accessType?: string;
}

export interface GetCrossTenantAccessAuditLogsRequest {
    sessionId?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    userId?: string;
    sourceTenantId?: string;
    targetTenantId?: string;
    accessGranted?: boolean;
    startDate?: Date;
    endDate?: Date;
}

export interface GetCrossTenantRoleAssignmentsRequest {
    sourceTenantId: string;
    targetTenantId: string;
    sessionId?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
}

export interface GetCrossTenantUsersRequest {
    sessionId?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sourceTenantId?: string;
}

export interface GetUserCrossTenantRolesRequest {
    userId: string;
    sessionId?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
}

export interface RevokeCrossTenantRolesOperationRequest {
    revokeCrossTenantRolesRequest: RevokeCrossTenantRolesRequest;
    sessionId?: string;
}

/**
 * CrossTenantAccessApi - interface
 * 
 * @export
 * @interface CrossTenantAccessApiInterface
 */
export interface CrossTenantAccessApiInterface {
    /**
     * Assigns roles to a user for cross-tenant access to specified target tenants.
     * @summary Assign cross-tenant roles
     * @param {AssignCrossTenantRolesRequest} assignCrossTenantRolesRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    assignCrossTenantRolesRaw(requestParameters: AssignCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>>;

    /**
     * Assigns roles to a user for cross-tenant access to specified target tenants.
     * Assign cross-tenant roles
     */
    assignCrossTenantRoles(requestParameters: AssignCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse>;

    /**
     * Checks if a user has cross-tenant access to a specific target tenant.
     * @summary Check cross-tenant access
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    checkCrossTenantAccessRaw(requestParameters: CheckCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Checks if a user has cross-tenant access to a specific target tenant.
     * Check cross-tenant access
     */
    checkCrossTenantAccess(requestParameters: CheckCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all users with access to the current tenant, including both native and cross-tenant users.
     * @summary Get accessible users
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [accessType] Filter by access type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    getAccessibleUsersRaw(requestParameters: GetAccessibleUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessListResponse>>;

    /**
     * Retrieves all users with access to the current tenant, including both native and cross-tenant users.
     * Get accessible users
     */
    getAccessibleUsers(requestParameters: GetAccessibleUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessListResponse>;

    /**
     * Retrieves audit logs for cross-tenant access attempts and operations.
     * @summary Get cross-tenant access audit logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [userId] User ID filter
     * @param {string} [sourceTenantId] Source tenant filter
     * @param {string} [targetTenantId] Target tenant filter
     * @param {boolean} [accessGranted] Access granted filter
     * @param {Date} [startDate] Start date
     * @param {Date} [endDate] End date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    getCrossTenantAccessAuditLogsRaw(requestParameters: GetCrossTenantAccessAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves audit logs for cross-tenant access attempts and operations.
     * Get cross-tenant access audit logs
     */
    getCrossTenantAccessAuditLogs(requestParameters: GetCrossTenantAccessAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all cross-tenant role assignments for a specific tenant relationship.
     * @summary Get cross-tenant role assignments
     * @param {string} sourceTenantId Source tenant ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    getCrossTenantRoleAssignmentsRaw(requestParameters: GetCrossTenantRoleAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>>;

    /**
     * Retrieves all cross-tenant role assignments for a specific tenant relationship.
     * Get cross-tenant role assignments
     */
    getCrossTenantRoleAssignments(requestParameters: GetCrossTenantRoleAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse>;

    /**
     * Retrieves only cross-tenant users who have access to the current tenant.
     * @summary Get cross-tenant users
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sourceTenantId] Source tenant filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    getCrossTenantUsersRaw(requestParameters: GetCrossTenantUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessListResponse>>;

    /**
     * Retrieves only cross-tenant users who have access to the current tenant.
     * Get cross-tenant users
     */
    getCrossTenantUsers(requestParameters: GetCrossTenantUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessListResponse>;

    /**
     * Retrieves all cross-tenant roles for a specific user across all accessible tenants.
     * @summary Get user cross-tenant roles
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    getUserCrossTenantRolesRaw(requestParameters: GetUserCrossTenantRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>>;

    /**
     * Retrieves all cross-tenant roles for a specific user across all accessible tenants.
     * Get user cross-tenant roles
     */
    getUserCrossTenantRoles(requestParameters: GetUserCrossTenantRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse>;

    /**
     * Revokes cross-tenant roles from a user for specified target tenants.
     * @summary Revoke cross-tenant roles
     * @param {RevokeCrossTenantRolesRequest} revokeCrossTenantRolesRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossTenantAccessApiInterface
     */
    revokeCrossTenantRolesRaw(requestParameters: RevokeCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>>;

    /**
     * Revokes cross-tenant roles from a user for specified target tenants.
     * Revoke cross-tenant roles
     */
    revokeCrossTenantRoles(requestParameters: RevokeCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse>;

}

/**
 * 
 */
export class CrossTenantAccessApi extends runtime.BaseAPI implements CrossTenantAccessApiInterface {

    /**
     * Assigns roles to a user for cross-tenant access to specified target tenants.
     * Assign cross-tenant roles
     */
    async assignCrossTenantRolesRaw(requestParameters: AssignCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>> {
        if (requestParameters['assignCrossTenantRolesRequest'] == null) {
            throw new runtime.RequiredError(
                'assignCrossTenantRolesRequest',
                'Required parameter "assignCrossTenantRolesRequest" was null or undefined when calling assignCrossTenantRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/roles/assign`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCrossTenantRolesRequestToJSON(requestParameters['assignCrossTenantRolesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleAssignmentResponseFromJSON(jsonValue));
    }

    /**
     * Assigns roles to a user for cross-tenant access to specified target tenants.
     * Assign cross-tenant roles
     */
    async assignCrossTenantRoles(requestParameters: AssignCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse> {
        const response = await this.assignCrossTenantRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a user has cross-tenant access to a specific target tenant.
     * Check cross-tenant access
     */
    async checkCrossTenantAccessRaw(requestParameters: CheckCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling checkCrossTenantAccess().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling checkCrossTenantAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/access/check/{userId}/{targetTenantId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"targetTenantId"}}`, encodeURIComponent(String(requestParameters['targetTenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Checks if a user has cross-tenant access to a specific target tenant.
     * Check cross-tenant access
     */
    async checkCrossTenantAccess(requestParameters: CheckCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkCrossTenantAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all users with access to the current tenant, including both native and cross-tenant users.
     * Get accessible users
     */
    async getAccessibleUsersRaw(requestParameters: GetAccessibleUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['accessType'] != null) {
            queryParameters['accessType'] = requestParameters['accessType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/users/accessible`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAccessListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all users with access to the current tenant, including both native and cross-tenant users.
     * Get accessible users
     */
    async getAccessibleUsers(requestParameters: GetAccessibleUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessListResponse> {
        const response = await this.getAccessibleUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit logs for cross-tenant access attempts and operations.
     * Get cross-tenant access audit logs
     */
    async getCrossTenantAccessAuditLogsRaw(requestParameters: GetCrossTenantAccessAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['sourceTenantId'] != null) {
            queryParameters['sourceTenantId'] = requestParameters['sourceTenantId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        if (requestParameters['accessGranted'] != null) {
            queryParameters['accessGranted'] = requestParameters['accessGranted'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/audit/access`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves audit logs for cross-tenant access attempts and operations.
     * Get cross-tenant access audit logs
     */
    async getCrossTenantAccessAuditLogs(requestParameters: GetCrossTenantAccessAuditLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCrossTenantAccessAuditLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all cross-tenant role assignments for a specific tenant relationship.
     * Get cross-tenant role assignments
     */
    async getCrossTenantRoleAssignmentsRaw(requestParameters: GetCrossTenantRoleAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>> {
        if (requestParameters['sourceTenantId'] == null) {
            throw new runtime.RequiredError(
                'sourceTenantId',
                'Required parameter "sourceTenantId" was null or undefined when calling getCrossTenantRoleAssignments().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling getCrossTenantRoleAssignments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/roles/relationship/{sourceTenantId}/{targetTenantId}`;
        urlPath = urlPath.replace(`{${"sourceTenantId"}}`, encodeURIComponent(String(requestParameters['sourceTenantId'])));
        urlPath = urlPath.replace(`{${"targetTenantId"}}`, encodeURIComponent(String(requestParameters['targetTenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleAssignmentResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all cross-tenant role assignments for a specific tenant relationship.
     * Get cross-tenant role assignments
     */
    async getCrossTenantRoleAssignments(requestParameters: GetCrossTenantRoleAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse> {
        const response = await this.getCrossTenantRoleAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves only cross-tenant users who have access to the current tenant.
     * Get cross-tenant users
     */
    async getCrossTenantUsersRaw(requestParameters: GetCrossTenantUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sourceTenantId'] != null) {
            queryParameters['sourceTenantId'] = requestParameters['sourceTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/users/cross-tenant`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAccessListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves only cross-tenant users who have access to the current tenant.
     * Get cross-tenant users
     */
    async getCrossTenantUsers(requestParameters: GetCrossTenantUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessListResponse> {
        const response = await this.getCrossTenantUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all cross-tenant roles for a specific user across all accessible tenants.
     * Get user cross-tenant roles
     */
    async getUserCrossTenantRolesRaw(requestParameters: GetUserCrossTenantRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserCrossTenantRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/roles/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleAssignmentResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all cross-tenant roles for a specific user across all accessible tenants.
     * Get user cross-tenant roles
     */
    async getUserCrossTenantRoles(requestParameters: GetUserCrossTenantRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse> {
        const response = await this.getUserCrossTenantRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes cross-tenant roles from a user for specified target tenants.
     * Revoke cross-tenant roles
     */
    async revokeCrossTenantRolesRaw(requestParameters: RevokeCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAssignmentResponse>> {
        if (requestParameters['revokeCrossTenantRolesRequest'] == null) {
            throw new runtime.RequiredError(
                'revokeCrossTenantRolesRequest',
                'Required parameter "revokeCrossTenantRolesRequest" was null or undefined when calling revokeCrossTenantRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/cross-tenant/roles/revoke`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RevokeCrossTenantRolesRequestToJSON(requestParameters['revokeCrossTenantRolesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleAssignmentResponseFromJSON(jsonValue));
    }

    /**
     * Revokes cross-tenant roles from a user for specified target tenants.
     * Revoke cross-tenant roles
     */
    async revokeCrossTenantRoles(requestParameters: RevokeCrossTenantRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAssignmentResponse> {
        const response = await this.revokeCrossTenantRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
